WL.registerComponent('sketch-shape', {
}, {
    init: function () {
        this.myShape = null;
    }
});